import { Theme } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";
import { LegendItem } from "@/Components/v2/molecule/LegendItem/LegendItem";

type LegendItemsProps = {
  theme: Theme;
  showLength: boolean;
  showPeak: boolean;
  setShowLength: (showLength: boolean) => void;
  setShowPeak: (showPeak: boolean) => void;
};

const LegendItems = ({
  theme,
  showLength,
  showPeak,
  setShowLength,
  setShowPeak,
}: LegendItemsProps) => (
  <>
    <Box border={`1px solid ${theme.palette.divider}`} borderRadius={20} py={0.5} px={1}>
      <LegendItem
        item={{
          id: "length",
          color: theme.palette.adStockChart?.length,
          title: "Length of Effect",
          isActive: showLength,
        }}
        handleClick={() => setShowLength(!showLength)}
      />
    </Box>
    <Box border={`1px solid ${theme.palette.divider}`} borderRadius={20} py={0.5} px={1}>
      <LegendItem
        item={{
          id: "peak",
          color: theme.palette.adStockChart?.peak,
          title: "Peak Effect Point",
          isActive: showPeak,
        }}
        handleClick={() => setShowPeak(!showPeak)}
      />
    </Box>
  </>
);

export default LegendItems;
